require('./bootstrap');

window.flatpickr = require("flatpickr");


// window.Alpine = require('alpinejs');
window.Vue = require('vue');
window.Services = require('@vue/Utils/Services').default;
window.VSelect = require("vue-select").default;

window.ApexCharts = require("apexcharts");

setTimeout(function(){

	Vue.component('v-select', VSelect);
	Vue.component('user-form', require('@vue/Components/UserForm.vue').default);
	Vue.component('role-form', require('@vue/Components/RoleForm.vue').default);

	let root = document.getElementById('vue__app');

	if(root){
		const app = new Vue({
			el: "#vue__app"
		});
	}


}, 1);
